<template>
  <div class="Subpage">
    <router-view />

    <Bigmenu
      :NavStatus="Bignav"
      :Way="5"
      :ShowBackBtn="true"
      v-on:cellback="OpenStatus"
      style="z-index: 2"
    ></Bigmenu>
    <div class="frame" style="z-index: -2"></div>
    <Submenu
      v-if="!Bignav"
      :Info="SubInfo"
      :DividNum="4"
      :BGImgUrl="'sbg02.png'"
      :Submenu="Submenu"
      v-on:cellback="Navgo"
      style="z-index: -6"
    ></Submenu>
  </div>
</template>

<script>
import Bigmenu from "@/components/Bigmenu.vue";
import Back from "@/components/Back.vue";
import Submenu from "@/components/Submenu.vue";
export default {
  name: "About",
  data() {
    return {
      Bignav: false,
      SubInfo: {
        title: "精準放射手術",
        body: ""
      },
      Submenu: [
        // {
        //   id: "01",
        //   text: "呼吸閘控放射治療"
        // },
        // {
        //   id: "02",
        //   text: "體表偵測放射治療"
        // },
        {
          id: "01",
          text: "何謂放射手術"
        },
        {
          id: "02",
          text: "精準放射手術 <br> HyperArc超弧刀"
        },
        {
          id: "03",
          text: "RapidArc Dynamic雙弧刀"
        }
        // {
        //   id: "04",
        //   text: "Halcyon新世代環形治療系統"
        // },
        // 線上/離線適應性放射治療已移至「適應性治療」分類（/Adaptive）
      ]
    };
  },
  components: {
    Back,
    Submenu,
    Bigmenu
  },
  methods: {
    Navgo(v) {
      switch (v) {
        case 0:
          this.$router.push("/R02");
          break;
        case 1:
          this.$router.push("/T03");
          break;
        case 2:
          this.$router.push("/T07");
          break;
      }
    },
    OpenStatus(v) {
      this.Bignav = v.status;
    }
  }
};
</script>
<style lang="scss" scoped>
.Subpage {
  height: 100%;
  width: 100%;
}
.frame {
  position: absolute;
  background-image: url("../assets/frame.png");
  background-position: center;
  height: 1080px;
  width: 1920px;
}
</style>
